import axios from "axios";

export default {
  configure(config) {
    this.client = axios.create({
      baseURL: config.http.baseURL
    });
  }
};
